import { h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { ResultItemContext } from '../../../types';

const PageResultItemTemplate = (context: ResultItemContext) => (
  <result-item
    type={context.item.type}
    class={context.hidden ? 'hidden' : ''}
    href={context.item.links['pip']} // TODO make the "pip" attribute access type-safe
    key={context.key}
    onClick={() => context.ref.onSelectItem(context.item, context.position, context.queryID, context.listType)}
    tabindex="0"
  >
    {context.item.category !== '' ? (
      <result-item-label
        link={context.item.links.category}
        onClick={(event: MouseEvent) =>
          context.ref.onCategoryClick(event, context.item, context.position, context.listType)
        }
      >
        {context.item.category}
      </result-item-label>
    ) : (
      <result-item-label></result-item-label>
    )}
    <result-item-headline>{context.item.name}</result-item-headline>
  </result-item>
);

export default PageResultItemTemplate;
